<template>
  <div>
    <v-overlay :value="loading" opacity="0.7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
      <v-card-text class="pb-0">
        <v-container fluid>
          <v-row>
            <v-col cols="2">
              <v-img v-if="!isShowFoto" src="@/assets/default_avatar.png" :aspect-ratio="3 / 4" />
              <v-img v-if="isShowFoto" :src="fotoUrl" :aspect-ratio="3 / 4" />
            </v-col>
            <v-col cols="10">
              <v-row>
                <v-col class="py-0">
                  <v-autocomplete
                    :error-messages="errors.cgm_id"
                    :items="itemsAutoCompletePessoa"
                    :loading="isloadingAutoCompletePessoa"
                    :rules="rules.cgm_id"
                    :search-input.sync="searchAutoCompletePessoa"
                    clearable
                    dense
                    hide-no-data
                    hide-selected
                    hint="Caso não encontre a pessoa, adicione utilizando o botão ao lado."
                    item-text="nome_documento"
                    item-value="id"
                    label="Motorista"
                    outlined
                    persistent-hint
                    placeholder="Digite no mínimo 3 caracteres"
                    v-model="formData.cgm_id"
                    @change="getPessoa"
                  >
                    <template v-slot:append-outer>
                      <v-btn @click="pessoaToggleForm" color="teal" dark depressed tile>
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                      </v-btn>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="pt-4">
                <v-col class="py-0" md="3" cols="12">
                  <v-text-field
                    :error-messages="errors.numero_cnh"
                    :rules="rules.numero_cnh"
                    counter="30"
                    class="pa-0"
                    dense
                    label="Número da CNH"
                    outlined
                    v-model="formData.numero_cnh"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" md="3" cols="12">
                  <v-autocomplete
                    :error-messages="errors.categoria_cnh_id"
                    :items="categorias_cnh"
                    :loading="isloadingCategoriaCnh"
                    :rules="rules.categoria_cnh_id"
                    clearable
                    dense
                    hide-no-data
                    hide-selected
                    item-text="nome"
                    item-value="id"
                    label="Categoria CNH"
                    outlined
                    persistent-hint
                    placeholder="Selecione uma categoria"
                    v-model="formData.categoria_cnh_id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col class="py-0" md="3" cols="12">
                  <v-text-field
                    :error-messages="errors.expedicao_cnh"
                    class="pa-0"
                    dense
                    label="Data Expedição CNH"
                    outlined
                    type="date"
                    v-model="formData.expedicao_cnh"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" md="3" cols="12">
                  <v-text-field
                    class="pa-0"
                    dense
                    label="Data Validade CNH"
                    outlined
                    type="date"
                    v-model="formData.validade_cnh"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-switch v-model="formData.ativo" label="Ativo?"></v-switch>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="py-2 px-4">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          :loading="isloadingSubmit"
          color="green"
          dark
          depressed
          type="submit"
        >
          <v-icon left small>mdi-send</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-form>
    <ModalPessoaForm />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { max, required } from '@/services/util/validate';
import pessoaHttp from '@/services/http/resources/configuracao/pessoaHttp';
import categoriaCnhHttp from '@/services/http/resources/frota/categoriaCnhHttp';
import toastMessage, { toastResponseError } from '@/services/util/alertService';
import ModalPessoaForm from '@/views/private/configuracao/pessoa/ModalForm.vue';

export default {
  name: 'MotoristaForm',
  components: { ModalPessoaForm },
  metaInfo: {
    title: 'Motorista',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Adicionar Motorista',
    valid: true,
    pessoa: null,
    categorias_cnh: [],
    formData: {
      id: '',
      cgm_id: '',
      categoria_cnh_id: '',
      numero_cnh: '',
      expedicao_cnh: '',
      validade_cnh: '',
      ativo: false,
    },
    formDataDefault: {
      id: '',
      cgm_id: '',
      categoria_cnh_id: '',
      numero_cnh: '',
      expedicao_cnh: '',
      validade_cnh: '',
      ativo: false,
    },
    rules: {
      numero_cnh: [(value) => max(value, 30)],
      cgm_id: [required],
      categoria_cnh_id: [required],
    },
    errors: {
      numero_cnh: [],
      cgm_id: [],
      categoria_cnh_id: [],
      url: [],
    },
    loading: false,
    isloadingSubmit: false,
    isloadingCategoriaCnh: false,
    isloadingAutoCompletePessoa: false,
    itemsAutoCompletePessoa: [],
    searchAutoCompletePessoa: '',
  }),
  computed: {
    ...mapState('motorista', ['dataIndex', 'data']),
    isShowFoto() {
      return !!(this.pessoa && this.pessoa.foto);
    },
    fotoUrl() {
      return this.isShowFoto ? this.pessoa.foto.foto_url : null;
    },
  },
  created() {
    this.checkEdit();
  },
  mounted() {
    this.$bus.$on('checkPessoa', (pessoa) => {
      this.changePessoa(pessoa);
    });
  },
  methods: {
    ...mapActions('pessoa', { pessoaToggleForm: 'toggleForm', find: 'find' }),
    ...mapActions('motorista', ['edit', 'store', 'update', 'setDataIndex', 'clearData', 'reset']),
    getPessoa() {
      if (this.formData.cgm_id) {
        this.find({ id: this.formData.cgm_id }).then(({ data: { data } }) => {
          this.pessoa = data;
        });
      } else {
        this.pessoa = null;
      }
    },
    changePessoa(data) {
      this.itemsAutoCompletePessoa.push(data);
      this.formData.cgm_id = data.id;
    },
    checkEdit() {
      this.loadCategoriasCnh();
      if (this.$route.params.id) {
        this.edit({ id: this.$route.params.id }).then(() => {
          this.openDialogForm();
        });
      }
    },
    openDialogForm() {
      this.resetValidation();
      this.resetAutoComplete();
      Object.entries(this.formDataDefault).forEach(([key]) => {
        if (key === 'cgm_id' && this.data[key]) {
          this.formData[key] = this.data[key];
          this.itemsAutoCompletePessoa.push(this.data.pessoa);
          this.getPessoa();
        } else {
          this.formData[key] = this.data[key];
        }
        this.pessoa = null;
      });
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.pessoa = null;
        this.resetValidation();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        const actionHttp = !this.$route.params.id
          ? this.store(this.formData)
          : this.update(this.formData);
        actionHttp
          .then(({ data: { data } }) => {
            if (!this.$route.params.id) {
              this.$router.push({ name: 'frota.motorista.editar', params: { id: data.id } });
            }
            toastMessage.successSave('Motorista salvo com sucesso');
            this.resetValidation();
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave('Erro ao salvar veículo');
            }
          })
          .finally(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    loadAutoCompletePessoa(value, resourceHttp, id) {
      const index = this.itemsAutoCompletePessoa.map((x) => x.id).indexOf(id);
      if (index > -1) return;
      this.isloadingAutoCompletePessoa = true;
      resourceHttp
        .listPessoa(value)
        .then(({ data: { data } }) => {
          this.itemsAutoCompletePessoa = data;
        })
        .catch((error) => toastResponseError(error))
        .finally(() => {
          this.isloadingAutoCompletePessoa = false;
        });
    },
    loadCategoriasCnh() {
      this.isloadingCategoriaCnh = true;
      categoriaCnhHttp
        .list()
        .then(({ data: { data } }) => {
          this.categorias_cnh = data;
        })
        .finally(() => {
          this.isloadingCategoriaCnh = false;
        });
    },
    resetAutoComplete() {
      this.itemsAutoCompletePessoa = [];
      this.searchAutoCompletePessoa = null;
      this.instituicoes = [];
      this.orgaos = [];
      this.perfis = [];
    },
  },
  watch: {
    'formData.cgm_id': function () {
      this.errors.cgm_id = [];
    },
    'formData.categoria_cnh_id': function () {
      this.errors.categoria_cnh_id = [];
    },
    'formData.url': function () {
      this.errors.url = [];
    },
    'formData.numero_cnh': function () {
      this.errors.numero_cnh = [];
    },
    searchAutoCompletePessoa(value) {
      if (!value) return;
      if (value.length < 3) return;
      if (this.isloadingAutoCompletePessoa) return;
      this.loadAutoCompletePessoa(value, pessoaHttp, this.formData.cgm_id);
    },
  },
  destroyed() {
    this.closeDialog();
    this.reset();
  },
};
</script>

<style lang="scss">
.v-input__append-outer {
  .v-btn {
    margin-top: -5px;
  }
}
</style>
